import {
  Box,
  Flex,
  FormDateInput,
  FormSearchSelection,
  type OptionSelectionProps,
  Text,
} from '@shared/components';
import { formatDate } from '@shared/utils';

export interface BlockedEndDateSettingSectionProps {
  duration: {
    name: string;
    required?: boolean;
    options: OptionSelectionProps[];
    hidden?: boolean;
  };
  date: {
    name: string;
    required?: boolean;
    disabled?: boolean;
  };
  blockedUntil?: Date;
}

export default function BlockedEndDateSettingSection(
  props: Readonly<BlockedEndDateSettingSectionProps>,
) {
  const { duration, date, blockedUntil } = props;

  if (duration.hidden) {
    return null;
  }

  return (
    <Flex
      sx={(theme) => ({
        border: '1px solid',
        borderColor: theme.palette.grey[300],
        borderRadius: theme.shape.rounded(1.5),
        backgroundColor: theme.palette.grey[50],
        p: theme.spacing(4),
        gap: theme.spacing(4),
        width: 'fit-content',
      })}
    >
      <FormSearchSelection
        {...duration}
        label='ระยะเวลาปฏิบัติหน้าที่'
        placeholder='เลือกระยะเวลา'
        sx={{ width: '212px' }}
      />
      <Box
        sx={{
          width: '212px',
        }}
      >
        <FormDateInput
          {...date}
          label='วันที่สิ้นสุดปฏิบัติหน้าที่'
          placeholder='DD-MM-YYYY'
          inputFormat='DD-MM-YYYY'
        />
      </Box>
      <Text
        variant='body2'
        sx={{
          height: '48px',
          alignSelf: 'flex-end',
          alignContent: 'center',
        }}
      >
        {`(วันที่สิ้นสุดระงับสิทธิ์: ${blockedUntil ? formatDate(blockedUntil) : 'DD-MM-YYYY'})`}
      </Text>
    </Flex>
  );
}
